<template>
  <div v-if="visible" class="notification-bar">
    <span>{{ message }}</span>
    <button @click="dismiss" class="dismiss-button">{{ $t('generalMessages.dismiss') }}</button>
  </div>
</template>

<script>
export default {
  name: 'NotificationBarMessage',
  props: {
    message: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      visible: !this.$store.state.ui.notificationBarDismessed,
    };
  },
  methods: {
    dismiss() {
      this.$store.commit('changeNotificationBarDismessedStatus', true);
      this.visible = false;
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
.notification-bar {
  background-color: #ffa;
  padding: 5px;
  border: 1px solid #ccc;
  /* border-radius: 5px; */
  margin: 10px 0;
  font-weight: 600;
  color: black;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dismiss-button {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}
</style>
